import React from 'react';
import AnimateHeight from 'react-animate-height';

import ClearAllFiltersButton from 'components/consumer/ClearAllFiltersButton';

const ProductClearAllFiltersButton = ({ canClear, clearRefinement }) => (
  <AnimateHeight duration={300} height={canClear ? 'auto' : 0} animateOpacity>
    <div className="md:pb-5">
      <ClearAllFiltersButton onClick={clearRefinement}>
        Clear all
      </ClearAllFiltersButton>
    </div>
  </AnimateHeight>
);

export default ProductClearAllFiltersButton;
